<template>
  <div class="container-fluid py-4">
    <form
      @submit.prevent="createCompany"
      class="needs-validation"
      novalidate
      enctype="multipart/form-data"
    >
      <!-- Company Details Section -->
      <div class="card shadow-sm border-0 mb-4">
        <div class="card-header bg-light">
          <h5 class="mb-0">📑 Organization Details</h5>
        </div>
        <div v-if="loading" class="card-body">
          <loader />
        </div>
        <div v-if="!loading" class="card-body">
          <div class="row">
            <!-- Company Name -->
            <div class="col-md-6 mb-3">
              <label class="form-label">Company Name</label>
              <input
                v-model="company.company_name"
                type="text"
                class="form-control"
                required
              />
            </div>

            <!-- Company Email -->
            <div class="col-md-6 mb-3">
              <label class="form-label">Email</label>
              <input
                v-model="company.company_email"
                type="email"
                class="form-control"
              />
            </div>

            <!-- Company Phone -->
            <div class="col-md-6 mb-3">
              <label class="form-label">Phone</label>
              <input
                v-model="company.company_phone"
                type="text"
                class="form-control"
              />
            </div>

            <!-- Company Location -->
            <div class="col-md-6 mb-3">
              <label class="form-label">Location</label>
              <input
                v-model="company.company_location"
                type="text"
                class="form-control"
              />
            </div>

            <!-- Country -->
            <div class="col-md-6 mb-3">
              <label class="form-label">Country</label>
              <input
                v-model="company.country"
                type="text"
                class="form-control"
              />
            </div>

            <!-- Address -->
            <div class="col-md-6 mb-3">
              <label class="form-label">Address</label>
              <input
                v-model="company.address"
                type="text"
                class="form-control"
              />
            </div>

            <!-- Branch Group -->
            <div class="col-md-6 mb-3">
              <label class="form-label">Branch Group</label>
              <input
                v-model="company.branch_group"
                type="text"
                class="form-control"
              />
            </div>

            <!-- Logo Upload -->
            <div class="col-md-6 mb-3">
              <label class="form-label">Logo</label>
              <input
                type="file"
                @change="handleLogoUpload"
                class="form-control"
                accept="image/*"
              />
            </div>
          </div>
        </div>
      </div>

      <!-- Submit Button -->
      <div v-if="!loading" class="text-end">
        <button type="submit" class="btn btn-primary px-4">
          <i class="fas fa-save me-2"></i> Submit Organization Details Update
        </button>
      </div>
    </form>
  </div>
</template>

<script>
import loader from "../../special_clinics/dialysis/loader.vue";
import { generalApiRequest } from "../../../api/apiIndex";
import { generalApiUploadRequest } from "../../../api/apiIndex";
import showNotification from "../../../notification/notify";
// generalApiRequest,
export default {
  name: "CreateOrganization",
  data() {
    return {
      loading: false,
      company: {
        company_name: "",
        company_email: "",
        company_phone: "",
        company_location: "",
        country: "",
        address: "",
        branch_group: "",
        logo: null,
      },
    };
  },
  components: {
    loader,
  },
  methods: {
    handleLogoUpload(event) {
      this.company.logo = event.target.files[0];
    },
    async createCompany() {
      this.loading = true;
      const formData = new FormData();
      for (const key in this.company) {
        formData.append(key, this.company[key]);
      }
      try {
        const response = await generalApiUploadRequest(
          "updateCompany",
          formData,
          1
        );
        if (response.status) {
          showNotification("Company created successfully!");
        } else {
          alert("Err!");
        }
        // this.resetForm();
      } catch (error) {
        console.error(error);
        alert("Failed to update company");
      }
      this.get_org_data();
      this.loading = false;
    },
    resetForm() {
      for (let key in this.company) {
        this.company[key] = key === "logo" ? null : "";
      }
      for (let key in this.admin) {
        this.admin[key] = "";
      }
    },

    async get_org_data() {
      const url = "get_company_details";
      const body = {};
      const res = await generalApiRequest(url, "GET", body, 1);

      if (res) {
        console.log(res);

        const res_info = {
          company_name: res.data.company_name,
          company_email: res.data.company_email,
          company_phone: res.data.company_phone,
          company_location: res.data.company_location,
          country: res.data.country,
          address: res.data.address,
          branch_group: res.data.branch_group,
          logo: null,
        };
        this.company = res_info;
      }
    },
  },
  mounted() {
    this.get_org_data();
  },
};
</script>

<style scoped>
.card-header {
  border-bottom: 1px solid #e4e4e4;
}
label {
  font-weight: 500;
}
</style>
